import gql from 'graphql-tag';
import { FetchResult } from '@apollo/client';

import { UpdateConsentInput } from '@buy-viasat/types/build/bv';
import { client } from 'shared/containers/apollo';

export type UpdateConsentResponse = FetchResult<{ updateConsent: boolean | null }>;

const UPDATE_CONSENT = gql`
  mutation updateConsent($input: UpdateConsentInput!) {
    updateConsent(input: $input)
  }
`;

export default async function updateConsentAsync({
  input,
}: {
  input: UpdateConsentInput;
}): Promise<UpdateConsentResponse> {
  return client.mutate({
    mutation: UPDATE_CONSENT,
    variables: { input },
  });
}
